import { RootState } from 'utils/interfaces'

export const selectStation = (state: RootState) => state.station.station;
export const selectLots = (state: RootState) => state.station.lots;

export const selectLoadingProgress = (state: RootState) => state.station.loadingProgress;